const transparent = require('../images/transparent.gif');
const window = require('../images/window.gif');
const windowTitle = require('../images/window-title.gif');
const button = require('../images/button.gif');

const mxRubberBandStyles = {
  'div.mxRubberband': {
    position: 'absolute',
    overflow: 'hidden',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'rgba(0, 0, 255, 0.2)',
    background: 'rgba(0, 119, 255, 0.2)',
    opacity: 1.0,
    backdropFilter: 'saturate(300%) contrast(200%)',
    '-webkit-backdrop-filter': 'saturate(300%) contrast(200%)',
  },
};

const mxWindowStyles = {
  'div.mxWindow': {
    boxShadow: '3px 3px 12px #C0C0C0',
    background: `url(${window})`,
    border: '1px solid #c3c3c3',
    position: 'absolute',
    overflow: 'hidden',
    zIndex: 1,
  },
  'table.mxWindow': {
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    fontFamily: 'inherit',
    fontSize: '8pt',
  },

  'td.mxWindowTitle': {
    background: `url(${windowTitle}) repeat-x`,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    fontWeight: 'bold',
    overflow: 'hidden',
    height: '13px',
    padding: '2px',
    paddingTop:'4px',
    paddingBottom: '6px',
    color: 'black',
  },
  'td.mxWindowPane': {
    verticalAlign: 'top',
    padding: 0,
  },
  'div.mxWindowPane': {
    overflow: 'hidden',
    position: 'relative',
  },
  'td.mxWindowPane td': {
    fontFamily: 'inherit',
    fontSize: '8pt',
  },
  'td.mxWindowPane input, td.mxWindowPane select, td.mxWindowPane textarea, td.mxWindowPane radio': {
    border: '1px solid #8C8C8C',
    fontFamily: 'inherit',
    fontSize: '8pt',
    padding: '1px',
  },
  'td.mxWindowPane button': {
    background: `url(${button}) repeat-x`,
    fontFamily: 'inherit',
    fontSize: '8pt',
    padding: '2px',
    float: 'left',
  }
};

const mxToolbarStyles = {
  'img.mxToolbarItem': {
    marginRight: '6px',
    marginBottom: '6px',
    borderWidth: '1px',
  },
  'select.mxToolbarCombo': {
    verticalAlign: 'top',
    borderStyle: 'inset',
    borderWidth: '2px',
  },
  'div.mxToolbarComboContainer': {
    padding: '2px',
  },
  'img.mxToolbarMode': {
    margin: '2px',
    marginRight: '4px',
    marginBottom: '4px',
    borderWidth: 0,
  },
  'img.mxToolbarModeSelected': {
    margin: '0px',
    marginRight: '2px',
    marginBottom: '2px',
    borderWidth: '2px',
    borderStyle: 'inset',
  },
};

const mxEditorStyles = {
  '.mxCellEditor': {
    background: `url(${transparent})`,
    borderColor: 'transparent',
    borderStyle: 'solid',
    position: 'absolute',
    overflow: 'visible',
    wordWrap: 'normal',
    borderWidth: 0,
    minWidth: '1px',
    resize: 'none',
    padding: 0,
    margin: 0,
  },
  '.mxPlainTextEditor * ': {
    padding: 0,
    margin: 0,
  }
};

const mxTooltipStyles = {
  'div.mxTooltip': {
    boxShadow: '3px 3px 12px #C0C0C0',
    background: '#FFFFCC',
    border: '1px solid black',
    fontFamily:  'inherit',
    fontSize: '10pt',
    position: 'fixed',
    cursor: 'default',
    padding: '4px',
    color: 'black',
  },
};

const mxPopupMenuStyles = {
  'div.mxPopupMenu': {
    boxShadow: '3px 3px 12px #C0C0C0',
    background: `url(${window})`,
    position: 'absolute',
    border: '1px solid black',
  },

  'table.mxPopupMenu': {
    borderCollapse: 'collapse',
    margin: '1px 0px',
  },

  'tr.mxPopupMenuItem': {
    color: 'black',
    cursor: 'pointer',
  },

  'tr.mxPopupMenuItemHover': {
    backgroundColor: '#000066',
    color: '#FFF',
    cursor: '#000',
  },
  'td.mxPopupMenuItem': {
    padding: '2px 30px 2px 10px',
    whiteSpace: 'no-wrap',
    fontFamily:  'inherit',
    fontSize: '10pt',
  },
  'td.mxPopupMenuIcon': {
    backgroundColor: '#D0D0D0',
    padding: '2px 4px 2px 4px',
  },
  '.mxDisabled': {
    opacity: '0.2 !important',
    cursor: 'default !important',
  },
};


const MxGraphStyles = {
  ...mxEditorStyles,
  ...mxRubberBandStyles,
  ...mxToolbarStyles,
  ...mxWindowStyles,
  ...mxPopupMenuStyles,
  ...mxTooltipStyles,
};

export default MxGraphStyles;
